const joinNonEmptyStrings = (parts, delimiter) => parts.filter(el => !!el).join(delimiter);

const getAddressComponentsOfType = (place, type) => {
    let component = place.address_components.filter(x => x.types.includes(type));
    if (!component) {
        return "";
    }

    return joinNonEmptyStrings(component.map(c => c.long_name), ', ');
};

export const mapGooglePlaceToCommerceAddress = (place) => {
    if (!place.address_components) {
        return;
    }

    let mappedAddress = {
        country: '',
        postcodeZip: '',
        townCity: '',
        addressLine2: '',
        addressLine1: ''
    };

    mappedAddress.country = getAddressComponentsOfType(place, 'country');
    mappedAddress.postcodeZip = getAddressComponentsOfType(place, 'postal_code');
    mappedAddress.townCity = getAddressComponentsOfType(place, 'postal_town');

    const localityDetails = joinNonEmptyStrings([getAddressComponentsOfType(place, 'sublocality'),
                                                getAddressComponentsOfType(place, 'locality')],
                                                ', ');
    if(localityDetails) {
        mappedAddress.addressLine2 = localityDetails;
    }

    const route = getAddressComponentsOfType(place, 'route');

    const streetNumber = getAddressComponentsOfType(place, 'street_number');

    const premiseDetails = joinNonEmptyStrings([getAddressComponentsOfType(place, 'subpremise'), 
                                                getAddressComponentsOfType(place, 'premise')], 
                                                ', ');

    if(premiseDetails) {
        mappedAddress.houseNameNumber = premiseDetails;
        mappedAddress.addressLine1 = joinNonEmptyStrings([streetNumber, route], ' ');
    } 
    else {
        mappedAddress.houseNameNumber = streetNumber;
        mappedAddress.addressLine1 = route;
    }

    return mappedAddress;
}
